import { render, staticRenderFns } from "./membershipDemand.vue?vue&type=template&id=31f94562&"
import script from "./membershipDemand.vue?vue&type=script&lang=ts&"
export * from "./membershipDemand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "membershipDemand.vue"
export default component.exports